import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MarqueeStrip from "@/components/MarqueeStrip";
import StickyCallCta from "@/components/StickyCallCta";
import { Helmet } from "react-helmet-async";
import { Outlet } from "react-router-dom";
import {
  SITE_NAME,
  SITE_URL,
  SITE_DESCRIPTION,
  DEFAULT_OG_IMAGE,
  CONTACT_PHONE,
  CONTACT_EMAIL,
} from "@/lib/seo";

const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${SITE_URL}/#organization`,
  name: SITE_NAME,
  legalName: SITE_NAME,
  url: SITE_URL,
  logo: `${SITE_URL}/media/anytime-vending-machines-logo.png`,
  image: DEFAULT_OG_IMAGE,
  description: SITE_DESCRIPTION,
  telephone: CONTACT_PHONE,
  email: CONTACT_EMAIL,
  areaServed: [
    { "@type": "Country", name: "Australia" },
    { "@type": "Country", name: "United Kingdom" },
    { "@type": "Country", name: "United States" },
    { "@type": "Country", name: "Canada" },
  ],
  address: { "@type": "PostalAddress", addressCountry: "AU" },
  priceRange: "Free (qualifying sites)",
  sameAs: [],
};

const websiteJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  url: SITE_URL,
  name: SITE_NAME,
  description: SITE_DESCRIPTION,
  publisher: { "@id": `${SITE_URL}/#organization` },
  inLanguage: "en",
};

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#0A0A0A] text-white">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(organizationJsonLd)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(websiteJsonLd)}
        </script>
      </Helmet>
      <Header />
      <MarqueeStrip />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <StickyCallCta />
    </div>
  );
}
